import styled, { keyframes } from "styled-components";

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const LoaderContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(
    255,
    255,
    255,
    0.8
  ); /* fondo blanco semitransparente */
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 9999;
`;

const Spinner = styled.div`
  width: 60px;
  height: 60px;
  border: 6px solid #ccc; /* Color gris claro para el borde */
  border-top-color: #3c6cb1; /* Azul de Colbún para la parte superior */
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const LoadingText = styled.p`
  margin-top: 15px;
  font-size: 18px;
  color: #3c6cb1; /* Azul de Colbún */
  font-weight: bold;
`;

const CustomLoading = () => (
  <LoaderContainer>
    <Spinner />
    <LoadingText>Cargando...</LoadingText>
  </LoaderContainer>
);

export default CustomLoading;
